/* Project Import will be here */
import { getRewardsGiftProductsApi } from "services/rewards/rewards";
import { getErrorObject, errorToast } from "../../utilities/utils";
import Constants from "utilities/appConstants";
import { showMsgFromJson } from "reducers/common";
/* Project Import will be here */

export const types = {
    REWARDS_ORDER_PRODUCTS_REQUEST: "rewardsOrderProducts/REWARDS_ORDER_PRODUCTS_REQUEST",
    REWARDS_ORDER_PRODUCTS_SUCCESS: "rewardsOrderProducts/REWARDS_ORDER_PRODUCTS_SUCCESS",
    REWARDS_ORDER_PRODUCTS_FAILURE: "rewardsOrderProducts/REWARDS_ORDER_PRODUCTS_FAILURE"
};

const initialState = {
    productList: [],
    isLoading: false,
    error: null,
};

export const rewardsOrderProducts = (state = initialState, action) => {
    switch (action.type) {
        case types.REWARDS_ORDER_PRODUCTS_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case types.REWARDS_ORDER_PRODUCTS_SUCCESS:
            return {
                ...state,
                ...action.payload,
                error: null,
                isLoading: false
            };
        case types.REWARDS_ORDER_PRODUCTS_FAILURE:
            return {
                ...state,
                isLoading: false,
                productList: [],
                error: action.payload.error
            };
        default:
            return state;
    }
};

/* Get rewards product list */
export const getRewardsProductList = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: types.REWARDS_ORDER_PRODUCTS_REQUEST
        });

        try {
            /* Get applied filters */
            const appliedFilters = getState().rewardsAttrFilter;
            const reqObj = {
                AttrFilter: appliedFilters.selectedAttrFilter,
                Sorting: appliedFilters.selectedSortingFilter,
                MinPrice: appliedFilters.minPrice,
                VendorIds: appliedFilters.selectedVendor,
                MaxPrice: appliedFilters.maxPrice
            };
            
            const response = await getRewardsGiftProductsApi(reqObj);

            dispatch({
                type: types.REWARDS_ORDER_PRODUCTS_SUCCESS,
                payload: { productList: response.data.Data }
            });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.REWARDS_ORDER_PRODUCTS_FAILURE, false));
        }
    }
};


/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string, showToast: boolean = false) => {
    return (dispatch) => {
        const { message, errorCode } = getErrorObject(error);

        /* Update the error response in the store */
        if (type !== "")
            dispatch({ type: type, payload: { error: message } });

        /* Show error message */
        if (showToast) {
            /* If error code is exist show the error code message or show the error message returned by the API request */
            if (errorCode !== "")
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    }
};